export default "__VITE_ASSET__d9aeb866__"